import React from 'react';
import styled from 'styled-components';

import { Switcher } from '@lt/components';

type ListType = {
  id: string;
  label: string;
  selected?: boolean;
  disabled?: boolean;
};

export const StyledSwitcher = (props) => <StyledSwitcherComp {...props} />;

type StyledSwitcher = {
  className: string;
  list: ListType[];
  onChange: boolean;
  order: 'asc' | 'desc';
  isMobile: boolean;
};

const StyledSwitcherComp = styled(Switcher)`
  width: 100%;
  height: 37px;
  max-width: calc(100% - 12px);
`;
